// extracted by mini-css-extract-plugin
export var tocpicsGobackBtn = "bB_fb";
export var topicsFilterContainer = "bB_d8";
export var topicsFilterWrapper = "bB_d9";